import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Popover, Box } from "@mui/material";
import { useAiRoutes } from "../../App/useAiRoutes";
import { RobotIcon } from "@fluentui/react-icons-northstar";
const AiDropdownMenu = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { aiRoutes, extensionInfo } = useAiRoutes(props.selectedExtension);
  const [showIconsOnly, setShowIconsOnly] = useState(false);
  const [availableWidth, setAvailableWidth] = useState(0);
  const navRef = useRef(null);

  // Responsive navigation handling
  useEffect(() => {
    const handleResize = () => {
      if (navRef.current) {
        const navWidth = navRef.current.offsetWidth;
        const rightNavWidth =
          document.querySelector(".rightNav")?.offsetWidth || 200;
        const logoWidth = window.innerWidth < 930 ? 70 : 166;
        const availableNavWidth =
          window.innerWidth - logoWidth - rightNavWidth - 100; // 100px buffer

        setAvailableWidth(availableNavWidth);
        // Show icons only when available width is less than 800px (approximate width needed for all nav items)
        setShowIconsOnly(availableNavWidth < 800 && window.innerWidth > 790);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleLinkClick = (tab) => {
    props.setSelectedTab(tab);
    handleClose();
  };

  // Check if any non-excluded extension is enabled
  const hasEnabledExtensions = aiRoutes.length > 0 && extensionInfo;

  // Check if current selected tab is one of the AI routes
  const isCurrentTabActive = aiRoutes.some(
    (route) => route.path === props.selectedTab
  );

  // Get the display name - if current tab is active, show the extension name, otherwise show "AI Studio"
  const getDisplayName = () => {
    if (isCurrentTabActive) {
      // Find the selected route to get its name
      const selectedRoute = aiRoutes.find(
        (route) => route.path === props.selectedTab
      );
      if (selectedRoute) {
        return selectedRoute.name;
      }
      // Fallback to extension info name
      if (extensionInfo) {
        return extensionInfo.name;
      }
    }
    return "AI Studio";
  };

  // Get the active class - if current tab is active, apply active styling
  const getActiveClass = () => {
    if (isCurrentTabActive) {
      // Find the selected route to get its type
      const selectedRoute = aiRoutes.find(
        (route) => route.path === props.selectedTab
      );
      const activeType =
        selectedRoute?.type || extensionInfo?.type || "ai-studio";
      return props.isActive(activeType, open);
    }
    return "";
  };

  return hasEnabledExtensions ? (
    <>
      <Box
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose} // 👈 Close when mouse leaves the trigger
        sx={{
          display: "inline-block",
          cursor: "pointer",
          position: "relative",
        }}
      >
        <Link
          to="#"
          onClick={handleClose}
          className={`button ${getActiveClass()}`}
          ref={navRef}
        >
          {showIconsOnly ? <RobotIcon outline size="large" /> : getDisplayName()}
        </Link>

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          PaperProps={{
            onMouseLeave: handleClose, // 👈 Close when mouse leaves the popover
            sx: { padding: 1 },
          }}
        >
          <Box display="flex" flexDirection="column" minWidth="150px">
            {aiRoutes.map((route) => (
              <Link
                key={route.path}
                to={`/${route.path}`}
                onClick={() => handleLinkClick(route.path)}
                style={{
                  padding: "8px",
                  textDecoration: "none",
                  fontWeight:
                    props.selectedTab === route.path ? "bold" : "normal",
                  color:
                    props.selectedTab === route.path
                      ? "rgb(98 100 167)"
                      : "black",
                }}
              >
                {route.name}
              </Link>
            ))}
          </Box>
        </Popover>
      </Box>
    </>
  ) : (
    <></>
  );
};

export default AiDropdownMenu;
